import { Instance, SnapshotOut, types } from 'mobx-state-tree'

import { GameModel } from './game'
import { GameModalQueue } from './game-modals'
import { Tournaments } from './tournament'
import { GameWalkthrough } from './game-walkthrough'
import { GameSheetQueue } from './game-sheets'
import { UserGameSchedule } from './game-user-schedule'
import { MyFirstGame } from './first-game/my-first-game'

/**
 * A GameStore model.
 */

export const GameStore = types
  .compose(GameModel, GameModalQueue, GameSheetQueue, Tournaments, GameWalkthrough, MyFirstGame, UserGameSchedule)
  .named('GameStore')

/**
 * The GameStore instance.
 */
export type GameStoreType = Instance<typeof GameStore>

/**
 * The data of a GameStore.
 */
export type GameStoreSnapshot = SnapshotOut<typeof GameStore>
